import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 5167 9303"
    {...props}
  >
    <defs>
      {/* <style>{".fil0{fill:#191919}"}</style> */}
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528322737760">
        <path
          d="m3186 8013 298 5c-7 228 102 950-141 971-259 23-155-786-157-976zm-1503 9 299-10c-3 191 101 1000-157 977-243-21-135-743-142-967zM1198 338c273-54 2678-44 2902 30 921 307 734 1216 734 2245v2991c0 735 194 1891-860 2081-290 52-2657 45-2897-28-345-105-635-401-719-778-63-283-25-3982-25-4448 0-843-196-1881 865-2093zm180 7675c-7 480-141 1277 439 1289 612 13 477-746 471-1289l591 1c-6 536-136 1263 435 1288 617 26 483-795 475-1289 503-16 759-206 1003-456 295-303 350-629 349-1150-2-997 0-1994 0-2991 0-728 132-2233-199-2759C4444-132 3693 11 2584 11 1494 11 747-134 240 635-110 1166 26 2676 26 3416c0 984 1 1969 0 2954-1 499 45 868 331 1168 246 259 504 458 1021 475z"
          className="fill"
        />
        <path
          d="M1474 5426h2219l1 983H1474l1-330-1-653zm2457-264c-148-96-1821-42-2150-43-600 0-618-113-616 485 2 310-27 809 24 1075 194 69 2596 70 2789 0 16-81 52-1243 19-1397l-66-120z"
          className="fill"
        />
        <path
          d="M2487 3189c311-68 585 159 645 414 84 354-148 628-406 687-760 175-1005-932-239-1101zm-766 701c186 1112 1893 874 1728-282-159-1119-1926-904-1728 282z"
          style={{
            fill: "#181818",
          }}
          className="fill"
        />
        <path
          d="M2637 5862c9 107-2 139-99 100-42-96-2-108 99-100zm-155-220c-338 112-191 713 210 551 334-135 180-681-210-551z"
          style={{
            fill: "#2b2a29",
            // stroke: "#2b2a29",
            strokeWidth: 104.243,
          }}
          className="fill"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
